<template>
  <div id="app">
    <router-view/>
    <BackTop/>
  </div>
</template>

<script>
// import Header from './components/Header'
// import Footer from './components/Footer'
// import Home from './pages/Home'

export default {
  name: 'app',
  components: {
    // Header,
    // Footer,
    // Home
  }
}
</script>

<style lang="scss">
@import "./styles/index";

#app {
  position: relative;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
@include media-tablet {
  #app {
    min-width: auto;
  }
}
</style>
